import(/* webpackMode: "eager" */ "/test-todo-app/app/global-error.tsx");
